import { useSearchParams } from "react-router-dom";
import { useEffect, useState } from "react";
import { genOrderNo } from "./useCartLocalStorage";

export const useBookingGroupNo = ({
  defaultValue = "",
  enabled = true,
  readonly = false,
}: {
  defaultValue?: string;
  enabled?: boolean;
  readonly?: boolean;
}) => {
  const [searchParams, setSearchParams] = useSearchParams();
  const [bookGroupNo, setBookingGroupNo] = useState(defaultValue);
  // set hash if not exists

  useEffect(() => {
    const replaceParam = (key: string, value: string) => {
      if (readonly) return; // do not modify search params if readonly
      const newParams = new URLSearchParams(searchParams);
      if (!enabled || value === null || value === undefined) {
        newParams.delete(key);
      } else {
        newParams.set(key, value);
      }
      setSearchParams(newParams, { replace: true }); // prevents adding to history stack
    };

    if (!bookGroupNo) {
      const s =
        defaultValue ||
        searchParams.get("group") ||
        (!enabled || readonly ? "" : genOrderNo());
      setBookingGroupNo(s);
      replaceParam("group", s);
    }
  }, [
    bookGroupNo,
    searchParams,
    setSearchParams,
    defaultValue,
    enabled,
    readonly,
  ]);

  return {
    bookGroupNo,
  };
};
